export default "__VITE_ASSET__DWC59lmA__"